import './App.css';
import { useState, useRef, useEffect } from 'react';
import { Navbar, Section1, Section2, Section3, ProjectSection, AboutSection, JourneySection, CertificateSection, BlogSection } from './Components/Components_file';
import ParticleCursor from './Components/shared/ParticleCursor';
import './Components/shared/particle-cursor.css';
import SkeletonLoader from './Components/shared/SkeletonLoader'; 
import PageSkeleton from './Components/shared/PageSkeleton'; // New skeleton for each page

function App() {
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState('home');
  const section3Ref = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []); // Reload skeleton when changing sections

  useEffect(() => {
    const disableActions = (event) => {
      if (event.type === "contextmenu" || event.type === "copy" || event.type === "cut") {
        event.preventDefault();
      }
    };
    
    const disableKeyboardShortcuts = (event) => {
      if (
        (event.ctrlKey && (event.key === "c" || event.key === "u" || event.key === "x" || event.key === "s" || event.key === "p")) ||
        event.key === "F12" ||
        (event.ctrlKey && event.shiftKey && (event.key === "I" || event.key === "J"))
      ) {
        event.preventDefault();
      }
    };

    document.addEventListener("contextmenu", disableActions);
    document.addEventListener("copy", disableActions);
    document.addEventListener("cut", disableActions);
    document.addEventListener("keydown", disableKeyboardShortcuts);

    return () => {
      document.removeEventListener("contextmenu", disableActions);
      document.removeEventListener("copy", disableActions);
      document.removeEventListener("cut", disableActions);
      document.removeEventListener("keydown", disableKeyboardShortcuts);
    };
  }, []);

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop,
        behavior: "smooth"
      });
    }
  };

  return (
    <>
      {window.innerWidth > 768 && <ParticleCursor />}
      <div className="App">
        <Navbar setActiveSection={setActiveSection} scrollToSection={() => scrollToSection(section3Ref)} />

        {loading ? (
          <SkeletonLoader /> // Global skeleton loader
        ) : (
          <>
            {activeSection === 'home' && (
              <>
                <div className='Section_1'>
                  <Section1 />
                </div>
                <div className='Section_2'>
                  <Section2 />
                </div>
                <div className='Section_3' ref={section3Ref}>
                  <Section3 />
                </div>
              </>
            )}
            {activeSection === 'projects' && (
              <div className='Project_Section'>
                {loading ? <PageSkeleton /> : <ProjectSection isVisible={activeSection === 'projects'} />}
              </div>
            )}
            {activeSection === 'AboutSection' && (
              <div className='About_Section'>
                {loading ? <PageSkeleton /> : <AboutSection isVisible={activeSection === 'AboutSection'} />}
              </div>
            )}
            {activeSection === 'JourneySection' && (
              <div className='Journey_Section'>
                {loading ? <PageSkeleton /> : <JourneySection isVisible={activeSection === 'JourneySection'} />}
              </div>
            )}
            {activeSection === 'CertificateSection' && (
              <div className='Certificate_Section'>
                {loading ? <PageSkeleton /> : <CertificateSection isVisible={activeSection === 'CertificateSection'} />}
              </div>
            )}
            {activeSection === 'BlogSection' && (
              <div className='Blog_Section'>
                {loading ? <PageSkeleton /> : <BlogSection isVisible={activeSection === 'BlogSection'} />}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}

export default App;
